module.exports = __webpack_public_path__ + "static/media/severe-illness-insurance-card-img.860ffd49.png";